import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { SwhcService } from "src/app/services/swhc/swhc.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-swhc3d",
  templateUrl: "./swhc3d.component.html",
  styleUrls: ["./swhc3d.component.scss"],
})
export class Swhc3dComponent implements OnInit, OnDestroy {
  constructor(private swhcService: SwhcService) {}

  @Input() position: any = {};
  slots: Observable<any>;
  zoneCoils: Observable<any>;
  zoneDies: Observable<any>;
  zoneSingulars: Observable<any>;
  getCoilStock: Observable<any>;
  getCranes: Observable<any>;
  environmentSend: object;
  protected slotsSub: Subscription;
  protected zoneCoilsSub: Subscription;
  protected zoneDiesSub: Subscription;
  protected zoneSingularsSub: Subscription;
  protected getCoilStockSub: Subscription;
  protected getCranesSub: Subscription;
  protected timeSub: Subscription;
  public liftwsSub: BehaviorSubject<any>;
  public depositwsSub: BehaviorSubject<any>;

  ngOnInit(): void {
    this.slotsSub = this.swhcService.slots().subscribe((data) => {
      this.slots = data;
    });

    this.zoneCoilsSub = this.swhcService.zoneCoils().subscribe((data) => {
      this.zoneCoils = data;
    });

    this.zoneDiesSub = this.swhcService.zoneDies().subscribe((data) => {
      this.zoneDies = data;
    });

    this.getCranesSub = this.swhcService.getCranes().subscribe((data) => {
      this.getCranes = data;
    });

    this.zoneSingularsSub = this.swhcService
      .zoneSingulars()
      .subscribe((data) => {
        this.zoneSingulars = data;
      });

    this.getCoilStockSub = this.swhcService.getCoilStock().subscribe((data) => {
      this.getCoilStock = data;
    });

    this.environmentSend = environment;

    // this.timeSub = this.swhcService.timeSubscription().subscribe((data) => {
    //   console.log("got data: ", data);
    // });

    this.liftwsSub = new BehaviorSubject<any>(null);
    this.swhcService.liftws().subscribe((data) => {
      console.log("got data lifted: ", data);
      data = data.lift;
      // se captura la data y se envia en una variable los parametros de content.step.uuid y content.step.position
      let returnmove = {
        // uuid: data.content.step.uuid,
        uuid: data.content.deposit,
        position: data.content.step.position,
        crane: data.content.crane,
        paramState: "lifted",
      };
      this.liftwsSub.next(returnmove);
    });

    this.depositwsSub = new BehaviorSubject<any>(null);
    this.swhcService.depositws().subscribe((data) => {
      console.log("got data deposited: ", data);
      data = data.deposit;
      let returnmove = {
        uuid: data.content.step.uuid,
        position: data.content.step.position,
        crane: data.content.crane,
        paramState: "deposited",
      };
      // se suscribe directamente a la funcion getCoilStockByDeposit y se envia el resultado al BehaviorSubject depositwsSub
      this.swhcService
        .getCoilStockByDeposit(returnmove.uuid)
        .subscribe((data) => {
          //se agrega returnmove.crane a data para poder enviarlo al BehaviorSubject
          let newData = {
            ...data,
            crane: returnmove.crane,
          };
          this.depositwsSub.next(newData);
        });
      console.log("activacion return coilDeposite: ", this.depositwsSub);
    });
  }

  debugger(debuggerPosition: any) {
    this.position = debuggerPosition;
  }

  debugger2() {
    console.log("positionLifted: ", this.position);
    this.position = JSON.parse(this.position);
    this.swhcService
      .debuggerLift(this.position.x, this.position.y, this.position.z)
      .subscribe(({ data }) => {
        console.log("got data: ", data);
      });
  }

  debugger3() {
    console.log("positionDeposited: ", this.position);
    this.position = JSON.parse(this.position);
    this.swhcService
      .debuggerDeposit(this.position.x, this.position.y, this.position.z)
      .subscribe(({ data }) => {
        console.log("got data: ", data);
      });
  }
  ngOnDestroy() {
    // desuscribirse de los observables
    this.slotsSub.unsubscribe();
    this.zoneCoilsSub.unsubscribe();
    this.zoneDiesSub.unsubscribe();
    this.zoneSingularsSub.unsubscribe();
    this.getCoilStockSub.unsubscribe();
    this.timeSub.unsubscribe();
  }
}
